import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllAuditTrail = async (params: any) => {
  const url = endpoints.VIEW_LIST_AUDIT_TRAIL;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const auditTrailService = {
  getAllAuditTrail,
};

export default auditTrailService;
